import Vue from 'vue'
import kxTemplate from './kxSelect'
// let select = Vue.extend(kxTemplate);

class kxSelect{
	constructor (){
		this.instances = [];
	}

	init (){

	}

	add (ins){
		this.instances.push(ins);

	}

	remove (ins){
		for(let [index,v] of this.instances.entries()){
			if(v._uid === ins._uid){
				this.instances.splice(index,1);
				break;
			}
		}
	}

	closeAll (){
		for(let [,v] of this.instances.entries()){
			v.close();
		}
	}

	closeOthers (ins){
		for(let [,v] of this.instances.entries()){
			if(v._uid !== ins._uid){
				v.close();
			}
		}
	}

	test (){

	}
}

let kxs = new kxSelect();
document.body.addEventListener('click',kxs.closeAll.bind(kxs));
document.body.addEventListener('touchstart',kxs.closeAll.bind(kxs));
export default {
	install (){
		Vue.prototype.$kxSelectPopper = kxs;
		Vue.component('kxSelectPopper',kxTemplate);
	}
}



// WEBPACK FOOTER //
// ./src/components/common/kxSelectPopper/index.js